/**
 * Helpers for the per-kind viewer filter sections: detect whether a given
 * artifact kind currently has any active narrowing filter so the filter toggle
 * can show its "active" indicator dot.
 *
 * @module components/share/public/PublicArtifactList/parts/shareViewerFilterUtils
 */
import type { ShareViewerFilters } from '@/types/share';

export type PublicListKind = 'task' | 'note' | 'obstruction';

/** Active list tab: every shared kind plus the cross-kind "all" view. */
export type PublicListTab = 'all' | PublicListKind;

function isNonEmptyArray(value: string[] | undefined): boolean {
  return value !== undefined && value.length > 0;
}

function isNonEmptyString(value: string | undefined): boolean {
  return value !== undefined && value.trim().length > 0;
}

/** True when the given kind has at least one active viewer filter. */
export function hasActiveViewerFilters(
  kind: PublicListKind,
  filters: ShareViewerFilters
): boolean {
  switch (kind) {
    case 'task':
      return (
        isNonEmptyArray(filters.taskStatuses) ||
        isNonEmptyArray(filters.taskPriorities) ||
        isNonEmptyString(filters.taskSearch) ||
        isNonEmptyString(filters.taskDueDateFrom) ||
        isNonEmptyString(filters.taskDueDateTo)
      );
    case 'note':
      return (
        isNonEmptyArray(filters.noteColors) ||
        isNonEmptyString(filters.noteSearch) ||
        isNonEmptyString(filters.noteDateFrom) ||
        isNonEmptyString(filters.noteDateTo)
      );
    case 'obstruction':
      return (
        isNonEmptyArray(filters.obstructionTypes) ||
        isNonEmptyArray(filters.obstructionStatuses) ||
        isNonEmptyArray(filters.obstructionSeverities) ||
        isNonEmptyArray(filters.obstructionImpacts) ||
        isNonEmptyString(filters.obstructionRoad) ||
        isNonEmptyString(filters.obstructionContractor) ||
        isNonEmptyString(filters.obstructionDateFrom) ||
        isNonEmptyString(filters.obstructionDateTo)
      );
  }
}
